import { render, staticRenderFns } from "./AdditionalRecords.vue?vue&type=template&id=23a74cff&scoped=true"
import script from "./AdditionalRecords.vue?vue&type=script&lang=js"
export * from "./AdditionalRecords.vue?vue&type=script&lang=js"
import style0 from "./AdditionalRecords.vue?vue&type=style&index=0&id=23a74cff&prod&scoped=true&lang=css"
import style1 from "./AdditionalRecords.vue?vue&type=style&index=1&id=23a74cff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a74cff",
  null
  
)

export default component.exports